
import { useState } from 'react';
import { Sweepstakes } from '../useSweepstakesData';

export const DEFAULT_FORM_VALUES = {
  name: '',
  description: '',
  image_url: '',
  start_date: '',
  draw_date: '',
  eligibility_criteria: {
    min_points: 0,
    min_tier: 'standard',
    activity_required: false,
    activity_days: 30
  },
  prize_details: {
    points: 0,
    reward_id: null,
    description: ''
  }
};

export const useFormValues = () => {
  const [formValues, setFormValues] = useState(DEFAULT_FORM_VALUES);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    
    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      
      if (name.startsWith('eligibility_')) {
        const field = name.replace('eligibility_', '');
        setFormValues(prev => ({
          ...prev,
          eligibility_criteria: {
            ...prev.eligibility_criteria,
            [field]: checked
          }
        }));
      } else {
        setFormValues(prev => ({ ...prev, [name]: checked }));
      }
    } 
    else if (name.startsWith('eligibility_')) {
      const field = name.replace('eligibility_', '');
      const processedValue = type === 'number' ? Number(value) : value;
      
      setFormValues(prev => ({
        ...prev,
        eligibility_criteria: {
          ...prev.eligibility_criteria,
          [field]: processedValue
        }
      }));
    }
    else if (name.startsWith('prize_')) {
      const field = name.replace('prize_', '');
      const processedValue = field === 'points' ? Number(value) : value;
      
      setFormValues(prev => ({
        ...prev,
        prize_details: {
          ...prev.prize_details,
          [field]: processedValue
        }
      }));
    }
    else {
      setFormValues(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleTierChange = (value: string) => {
    setFormValues(prev => ({
      ...prev,
      eligibility_criteria: {
        ...prev.eligibility_criteria,
        min_tier: value
      }
    }));
  };

  const handleRewardChange = (value: string) => {
    setFormValues(prev => ({
      ...prev,
      prize_details: {
        ...prev.prize_details,
        reward_id: value === "none" ? null : value
      }
    }));
  };

  const handleCheckboxChange = (name: string, checked: boolean) => {
    if (name.startsWith('eligibility_')) {
      const field = name.replace('eligibility_', '');
      setFormValues(prev => ({
        ...prev,
        eligibility_criteria: {
          ...prev.eligibility_criteria,
          [field]: checked
        }
      }));
    } else {
      setFormValues(prev => ({ ...prev, [name]: checked }));
    }
  };

  const resetForm = () => {
    setFormValues(DEFAULT_FORM_VALUES);
  };

  return {
    formValues,
    setFormValues,
    handleInputChange,
    handleTierChange,
    handleRewardChange,
    handleCheckboxChange,
    resetForm
  };
};
